import React, { useState } from "react";
import { Upload, Button, Table, Select, message, Modal } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";

const { Option } = Select;

const ImportForm = () => {
  const [fileData, setFileData] = useState([]);
  const [columnMapping, setColumnMapping] = useState({});
  const [attributeColumns, setAttributeColumns] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);

  // Funkcija za čitanje fajla
  const handleFileUpload = (info) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet, { defval: "" });
      setFileData(json);
      setModalVisible(true);
    };
    reader.readAsArrayBuffer(info.file.originFileObj);
  };

  // Funkcija za mapiranje kolona
  const handleMappingChange = (fileColumn, mappedField) => {
    setColumnMapping((prev) => ({ ...prev, [fileColumn]: mappedField }));
  };

  // Dodavanje kao atribut
  const handleAddAttribute = (fileColumn) => {
    setAttributeColumns((prev) => [...prev, fileColumn]);
    message.success(`Kolona "${fileColumn}" dodata kao atribut`);
  };

  // Slanje podataka na backend
  const handleImport = () => {
    const mappedData = fileData.map((row) => {
      const newRow = {};

      // Standardno mapiranje
      Object.keys(columnMapping).forEach((fileColumn) => {
        const dbColumn = columnMapping[fileColumn];
        if (dbColumn) {
          newRow[dbColumn] = row[fileColumn];
        }
      });

      // Dodavanje atributa
      const attributes = {};
      attributeColumns.forEach((attrCol) => {
        if (row[attrCol]) {
          attributes[attrCol] = row[attrCol];
        }
      });

      newRow.attributes = attributes;
      return newRow;
    });

    console.log("📤 Slanje podataka na API:", mappedData);
    message.success("Podaci uspešno mapirani i spremni za unos!");

    // OVDJE POZIV API-JA ZA SNIMANJE U BAZU
  };

  return (
    <div>
      <Upload beforeUpload={() => false} onChange={handleFileUpload}>
        <Button icon={<UploadOutlined />}>Odaberi fajl</Button>
      </Upload>

      <Modal
        title="Mapiranje kolona"
        visible={modalVisible}
        onOk={handleImport}
        onCancel={() => setModalVisible(false)}
      >
        <Table
          dataSource={Object.keys(fileData[0] || {}).map((col) => ({
            column: col,
          }))}
          rowKey="column"
        >
          <Table.Column
            title="Kolona u fajlu"
            dataIndex="column"
            key="column"
          />
          <Table.Column
            title="Mapiraj na polje"
            key="mapping"
            render={(_, record) => (
              <Select
                style={{ width: 200 }}
                onChange={(value) => handleMappingChange(record.column, value)}
              >
                <Option value="name">Naziv proizvoda</Option>
                <Option value="sku">SKU</Option>
                <Option value="price">Cena</Option>
                <Option value="stock">Stanje na lageru</Option>
                <Option value="category">Kategorija</Option>
              </Select>
            )}
          />
          <Table.Column
            title="Dodaj kao atribut"
            key="attribute"
            render={(_, record) => (
              <Button
                type="link"
                onClick={() => handleAddAttribute(record.column)}
              >
                Dodaj kao atribut
              </Button>
            )}
          />
        </Table>
      </Modal>
    </div>
  );
};

export default ImportForm;
